import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungDresden() {
  return (
    <CityPageTemplate
      city="Dresden"
      slug="dresden"
      intro="Dresden verbindet Tradition und Moderne – Deine Finanzplanung sollte genauso zukunftsorientiert sein."
      description="Unabhängige Finanzberatung für Dresden – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
